import React from 'react'
import HeadTitle from '../../components/HeadTitle/HeadTitle'
import MyAccountForm from '../../components/forms/MyAccountForm'
import { useTranslation } from 'react-i18next'

/**
 * Shows the MyAccount page
 * @returns {JSX.Element} React stack to render
 */
// eslint-disable-next-line no-empty-pattern
function MyAccount({ match }) {
	const { t } = useTranslation('user')

	return (
		<>
			<HeadTitle title={t('GeneralInformations')} />
			<MyAccountForm match={match} />
		</>
	)
}
export default MyAccount
